module.exports = __webpack_public_path__ + "img/start_marker.9fece781.png";